(() => {
  if (window.dsProductAddonInitialized) return;
  window.dsProductAddonInitialized = true;

  const getSectionAddon = (form) => {
    const productSection =
      form.closest('.shopify-section') ||
      form.closest('product-info') ||
      document;

    return productSection.querySelector('[data-product-addon]');
  };

  const getMainProperties = (formData) => {
    const properties = {};

    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);

      if (match && value !== '') {
        properties[match[1]] = value;
      }
    }

    return properties;
  };

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;

      if (
        !(form instanceof HTMLFormElement) ||
        form.dataset.type !== 'add-to-cart-form'
      ) {
        return;
      }

      const addon = getSectionAddon(form);
      if (!addon) return;

      const checkbox = addon.querySelector('[data-addon-checkbox]');
      if (!checkbox?.checked || checkbox.disabled) return;

      /*
       * Detiene el envío normal de Dawn solamente cuando el complemento
       * está seleccionado.
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const submitButton = form.querySelector('[name="add"]');
      const errorElement = addon.querySelector('[data-addon-error]');

      if (errorElement) {
        errorElement.hidden = true;
        errorElement.textContent = '';
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('loading');
      }

      try {
        const formData = new FormData(form);

        const mainVariantId = Number(formData.get('id'));
        const mainQuantity = Math.max(
          1,
          Number(formData.get('quantity')) || 1
        );

        const addonVariantId = Number(addon.dataset.addonVariantId);
        const addonQuantityInput = addon.querySelector(
          '[data-addon-quantity]'
        );
        const addonQuantity = Math.max(
          1,
          Number(addonQuantityInput?.value) || 1
        );

        if (!mainVariantId || !addonVariantId) {
          throw new Error(
            'No fue posible identificar uno de los productos.'
          );
        }

        const mainItem = {
          id: mainVariantId,
          quantity: mainQuantity
        };

        const mainProperties = getMainProperties(formData);

        if (Object.keys(mainProperties).length > 0) {
          mainItem.properties = mainProperties;
        }

        const sellingPlan = formData.get('selling_plan');

        if (sellingPlan) {
          mainItem.selling_plan = Number(sellingPlan);
        }

        const response = await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [
                mainItem,
                {
                  id: addonVariantId,
                  quantity: addonQuantity
                }
              ]
            })
          }
        );

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
              result.message ||
              'No fue posible agregar los productos.'
          );
        }

        /*
         * Redirige al carrito para mostrar inmediatamente ambos productos.
         * Es la opción más estable para una modificación personalizada.
         */
        window.location.href = `${window.Shopify.routes.root}cart`;
      } catch (error) {
        console.error('Error al agregar complemento:', error);

        if (errorElement) {
          errorElement.textContent =
            error.message ||
            'Ocurrió un problema. Intenta nuevamente.';
          errorElement.hidden = false;
        }

        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('loading');
        }
      }
    },
    true
  );
})();